import * as React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import AirportShuttleRoundedIcon from '@mui/icons-material/AirportShuttleRounded';
import { Box, AppBar, Toolbar, IconButton, Typography, Menu, Container } from '@mui/material';

import ButtonsOptions from './SubComponents/ButtonsOptions';
import ButtonsUser from './SubComponents/ButtonsUser';

function AppBarMenu({ handleChangeOption, pages, numberOption, handleChangeNumberOption }) {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const [anchorElUser, setAnchorElUser] = React.useState(null);
  
    const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
    };
    const handleOpenUserMenu = (event) => {
      setAnchorElUser(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
      setAnchorElNav(null);
    };
    const handleCloseUserMenu = () => {
      setAnchorElUser(null);
    };
  
return (
  <AppBar position="static">
    <Container maxWidth="100%">
      <Toolbar disableGutters>

        {/* Logo e ícono - escritorio */}
        <AirportShuttleRoundedIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
        <Typography
          variant="h6"
          component="a"
          href="#"
          sx={{
            display: { xs: 'none', md: 'flex' },
            flexGrow: 0,
            paddingRight: 3,
            fontFamily: 'Bebas Neue, sans-serif',
            fontWeight: 'bold',
            letterSpacing: '.2rem',
            color: 'inherit',
            textDecoration: 'none',
          }}
        >
          Parqueadero Los Kioskitos
        </Typography>

        {/* Mobile: Botón de menú */}
        <Box sx={{ display: { xs: 'flex', md: 'none' }, flexGrow: 1 }}>
          <IconButton
            size="large"
            aria-label="menu"
            onClick={handleOpenNavMenu}
            color="inherit"
          >
            <MenuIcon />
          </IconButton>
          <Menu
            id="menu-appbar"
            anchorEl={anchorElNav}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
            transformOrigin={{ vertical: 'top', horizontal: 'left' }}
            open={Boolean(anchorElNav)}
            onClose={handleCloseNavMenu}
            sx={{ display: { xs: 'block', md: 'none' } }}
          >
            <ButtonsOptions
              handleCloseNavMenu={handleCloseNavMenu}
              handleChangeOption={handleChangeOption}
              pages={pages}
              isMenu={true}
              numberOption={numberOption}
              handleChangeNumberOption={handleChangeNumberOption}
            />
          </Menu>
        </Box>

        {/* Logo e ícono - mobile */}

        {/* Opciones del menú en escritorio */}
        <Box sx={{
          flexGrow: 1,
          display: { xs: 'none', md: 'flex' },
          paddingLeft: 3,
          backgroundColor: 'rgba(0,0,0,0.3)',
          flexWrap: 'wrap',
        }}>
          <ButtonsOptions
            handleCloseNavMenu={handleCloseNavMenu}
            handleChangeOption={handleChangeOption}
            pages={pages}
            isMenu={false}
            numberOption={numberOption}
            handleChangeNumberOption={handleChangeNumberOption}
          />
        </Box>

        {/* Usuario */}
        <ButtonsUser
          handleOpenUserMenu={handleOpenUserMenu}
          handleCloseUserMenu={handleCloseUserMenu}
          anchorElUser={anchorElUser}
        />

      </Toolbar>
    </Container>
  </AppBar>
);

}

export default AppBarMenu;